import { render, staticRenderFns } from "./header-title.vue?vue&type=template&id=71d021e1&"
import script from "./header-title.vue?vue&type=script&lang=js&"
export * from "./header-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports